import { render, staticRenderFns } from "./InstallsTab.vue?vue&type=template&id=3f40ea13"
import script from "./InstallsTab.vue?vue&type=script&lang=js"
export * from "./InstallsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports